module.exports = __webpack_public_path__ + "img/transaction.667be8b4.png";